import styled from 'styled-components'

export const StyledCard = styled.div<{ $isHovered?: boolean }>`
  padding: 16px;
  border: 1px solid
    ${({ theme, $isHovered }) =>
      $isHovered ? theme.colors.primary : '#e6e6e6'};
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 200ms ease-out;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:active {
    transform: translateY(0);
  }

  /* Mobile: reduce padding */
  @media (max-width: 768px) {
    padding: 12px;
  }

  /* Disable hover transform on touch devices */
  @media (hover: none) {
    &:hover {
      transform: none;
    }
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
`

export const AddressSection = styled.div`
  min-width: 0;
  flex: 1;
`

export const Address = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a1a;
  margin: 0 0 2px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Mobile: slightly smaller font */
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const Municipality = styled.p`
  font-size: 13px;
  line-height: 1.3;
  color: #666666;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const MetricsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin: 8px 0;
  padding: 8px 0;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;

  /* Mobile: reduce gap */
  @media (max-width: 768px) {
    gap: 6px 10px;
  }
`

export const Metric = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #404040;
`

export const MetricIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #808080;
`

export const MetricValue = styled.span`
  font-weight: 500;
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`

export const EgidText = styled.p`
  font-size: 12px;
  line-height: 1.4;
  color: #808080;
  margin: 0;
`

export const ViewLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  background: none;
  border: none;
  padding: 4px 0;
  cursor: pointer;
  transition: color 150ms ease-out;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryHover};
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: 2px;
  }
`
